'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslations } from 'next-intl';
import { InspectionPanelIcon, GroupIcon, TableIcon } from 'lucide-react';
import { Link } from '@/i18n/navigation';
import { Badge } from '@/components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ProductOemNumbersSection from '@/components/partials/products/product-oem-numbers-section';
import { getLocalizedValue } from '@/lib/utils';
import { ProductType, ProductOemType } from '@/types/product';
type PropsType = {
  product: ProductType;
  backendLocale: string;
  productsRoute: string;
  selectedOem?: ProductOemType;
  oemBaseHref: string;
};
const ProductDetailsSection = t0 => {
  const $ = _c(52);
  const {
    product,
    backendLocale,
    productsRoute,
    selectedOem,
    oemBaseHref
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== backendLocale || $[1] !== product) {
    t1 = getLocalizedValue(product, "content", backendLocale);
    $[0] = backendLocale;
    $[1] = product;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const productContent = t1;
  const hasContent = !!productContent && productContent !== "" && productContent !== "<p></p>";
  const hasOemNumbers = (product.oemNumbers?.length ?? 0) > 0;
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[3] !== backendLocale || $[4] !== hasContent || $[5] !== hasOemNumbers || $[6] !== oemBaseHref || $[7] !== product.oemNumbers || $[8] !== productContent || $[9] !== productsRoute || $[10] !== selectedOem || $[11] !== t) {
    const uniqueVehicleGroups = Array.from(new Map((product.oemNumbers ?? []).map(_temp)).values());
    const hasApplications = uniqueVehicleGroups.length > 0;
    const defaultTab = hasOemNumbers ? "also-suitable-to" : hasContent ? "details" : "applications";
    t8 = "rounded-lg border bg-white p-4 shadow-sm sm:p-5";
    T0 = Tabs;
    t2 = defaultTab;
    t3 = "w-full";
    let t9;
    if ($[20] !== hasOemNumbers || $[21] !== t) {
      t9 = hasOemNumbers && <TabsTrigger value="also-suitable-to" className="cursor-pointer p-3 text-base sm:p-6 sm:text-lg"><TableIcon /><span className="hidden sm:inline">{t("also_suitable_to")}</span></TabsTrigger>;
      $[20] = hasOemNumbers;
      $[21] = t;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    let t10;
    if ($[23] !== hasContent || $[24] !== t) {
      t10 = hasContent && <TabsTrigger value="details" className="cursor-pointer p-3 text-base sm:p-6 sm:text-lg"><InspectionPanelIcon /><span className="hidden sm:inline">{t("details")}</span></TabsTrigger>;
      $[23] = hasContent;
      $[24] = t;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    let t11;
    if ($[26] !== hasApplications || $[27] !== t) {
      t11 = hasApplications && <TabsTrigger value="applications" className="cursor-pointer p-3 text-base sm:p-6 sm:text-lg"><GroupIcon /><span className="hidden sm:inline">{t("applications")}</span></TabsTrigger>;
      $[26] = hasApplications;
      $[27] = t;
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    if ($[29] !== t10 || $[30] !== t11 || $[31] !== t9) {
      t4 = <TabsList variant="line" className="mb-3 gap-0! p-0">{t9}{t10}{t11}</TabsList>;
      $[29] = t10;
      $[30] = t11;
      $[31] = t9;
      $[32] = t4;
    } else {
      t4 = $[32];
    }
    if ($[33] !== hasOemNumbers || $[34] !== oemBaseHref || $[35] !== product.oemNumbers || $[36] !== selectedOem) {
      t5 = hasOemNumbers && <TabsContent value="also-suitable-to"><ProductOemNumbersSection oemNumbers={product.oemNumbers} selectedOem={selectedOem} oemBaseHref={oemBaseHref} /></TabsContent>;
      $[33] = hasOemNumbers;
      $[34] = oemBaseHref;
      $[35] = product.oemNumbers;
      $[36] = selectedOem;
      $[37] = t5;
    } else {
      t5 = $[37];
    }
    if ($[38] !== hasContent || $[39] !== productContent) {
      t6 = hasContent && <TabsContent value="details"><div className="prose prose-sm dark:prose-invert html-content max-w-none rounded-md bg-gray-50 p-5"><div dangerouslySetInnerHTML={{
            __html: productContent as string
          }} /></div></TabsContent>;
      $[38] = hasContent;
      $[39] = productContent;
      $[40] = t6;
    } else {
      t6 = $[40];
    }
    t7 = hasApplications && <TabsContent value="applications"><div className="flex flex-wrap gap-2 rounded-md bg-gray-50 p-5">{uniqueVehicleGroups.map(vg => <Badge key={vg.id} className="hover:bg-brand! rounded-md bg-neutral-600 px-3 py-1 text-sm font-semibold text-white transition-colors duration-300" asChild={true}><Link href={`${productsRoute}?applications=${getLocalizedValue(vg, "slug", backendLocale)}`}>{getLocalizedValue(vg, "title", backendLocale)}</Link></Badge>)}</div></TabsContent>;
    $[3] = backendLocale;
    $[4] = hasContent;
    $[5] = hasOemNumbers;
    $[6] = oemBaseHref;
    $[7] = product.oemNumbers;
    $[8] = productContent;
    $[9] = productsRoute;
    $[10] = selectedOem;
    $[11] = t;
    $[12] = T0;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    T0 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
  }
  let t9;
  if ($[41] !== T0 || $[42] !== t2 || $[43] !== t3 || $[44] !== t4 || $[45] !== t5 || $[46] !== t6 || $[47] !== t7) {
    t9 = <T0 defaultValue={t2} className={t3}>{t4}{t5}{t6}{t7}</T0>;
    $[41] = T0;
    $[42] = t2;
    $[43] = t3;
    $[44] = t4;
    $[45] = t5;
    $[46] = t6;
    $[47] = t7;
    $[48] = t9;
  } else {
    t9 = $[48];
  }
  let t10;
  if ($[49] !== t8 || $[50] !== t9) {
    t10 = <div className={t8}>{t9}</div>;
    $[49] = t8;
    $[50] = t9;
    $[51] = t10;
  } else {
    t10 = $[51];
  }
  return t10;
};
export default ProductDetailsSection;
function _temp(oem) {
  return [oem.vehicleGroup.id, oem.vehicleGroup];
}